function Senegal({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2054)">
  <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5069 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5069 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#FFDA44"/>
  <path d="M15.9998 10.4346L17.3811 14.6858H21.8516L18.2351 17.3135L19.6164 21.5649L15.9998 18.9374L12.3833 21.5649L13.7648 17.3135L10.1483 14.6858H14.6185L15.9998 10.4346Z" fill="#496E2D"/>
  <path d="M9.0435 1.58789C3.69163 4.17583 0 9.65639 0 15.9997C0 22.343 3.69163 27.8236 9.0435 30.4115V1.58789Z" fill="#496E2D"/>
  <path d="M22.9565 1.58789V30.4115C28.3084 27.8236 32 22.343 32 15.9997C32 9.65639 28.3084 4.17583 22.9565 1.58789Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Senegal;
